import { SuperProductLine, SuperProductLines } from './super-product-line'
import { z } from 'my-zod'

export const SuperProductTypeEnum = z.enum(['OffRoad', 'OnRoad', 'Snow', 'Water'])
export const SuperProductTypes = SuperProductTypeEnum.Values
export type SuperProductType = z.infer<typeof SuperProductTypeEnum>
export function GetProductTypeBySuperProductLine(superProductLine: SuperProductLine) {
  switch (superProductLine) {
    case SuperProductLines.ACE:
    case SuperProductLines.ATV:
    case SuperProductLines.SXS:
      return SuperProductTypes.OffRoad
    case SuperProductLines.SLG:
    case SuperProductLines.IND:
      return SuperProductTypes.OnRoad
    case SuperProductLines.SNO:
      return SuperProductTypes.Snow
    case SuperProductLines.PON:
      return SuperProductTypes.Water
  }
}
